import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { api } from '../../api/config';
import HalfSizeBanner from '../../components/Banners/HalfSizeBanner';
import { Box, Button, Typography } from '@mui/material';
import Loader from '../../components/Loader/Loader';

export default function BlogList() {

    const navigate = useNavigate();
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const language = useSelector((state) => state.language.language);

    const LimitedText = ({ text, limit }) => {
        const truncatedText = text?.split(" ")?.slice(0, limit)?.join(" ");
        return <p>{truncatedText}...</p>;
    };


    const handleObtain = () => {
        setLoading(true)
        api.post('/page/getBlogs', { lang: language })
            .then(res => {

                setBlogs(res?.data?.blogs);
            })
            .finally(() => {
                setLoading(false);
            })
    }

    useEffect(() => {
        handleObtain();
        //eslint-disable-next-line
    }, [language])

    return (
        <Grid>
            {
                loading
                    ?
                    <Loader />
                    :
                    <>
                        <HalfSizeBanner>
                            <Box bgcolor={'#1E353D'} height={1}>
                                <Box component={'img'} src={`${process.env.REACT_APP_SITE_URL}/images/2026/03/Blogs-banner.png`} width={1} height={1} className='fitCover' />
                            </Box>
                        </HalfSizeBanner>

                        <Grid container className="generalContainer" spacing={4} mx={'auto'} mb={{ md: '92px', xs: '50px' }} mt={{ md: '80px', xs: '50px' }}>
                            {blogs &&
                                blogs?.map((blog, index) => (
                                    <Grid size={{md: 4, xs: 12}} key={index}>
                                        <Box width={1} height={'340px'}>
                                            <Box component={'img'} src={`${process.env.REACT_APP_SITE_URL}/${blog?.path}`} height={1} width={1} className='fitCover' />
                                        </Box>
                                        <Box mt={'33px'}>
                                            <Typography variant="body1" color='text.secondary' fontWeight={'bold'} fontSize={'24px'} textAlign={'center'}>{blog?.title}</Typography>
                                        </Box>
                                        <Box mt={'7px'} px={'10px'}>
                                            <Typography variant="body1" fontSize={'1rem'} color='text.secondary' textAlign={'center'}>
                                                <LimitedText text={blog?.meta_description} limit={15} />
                                            </Typography>
                                        </Box>
                                        <Box mt={'20px'} display={'flex'} justifyContent={'center'}>
                                            <Button onClick={() => navigate((`${blog?.slug}`))} fullWidth variant='contained' className='borderRadiusFlat borderWidth2 buttonPaddingY10 placeBorder defaultBorderColor defaultButton noShadow buttonTextSize' color='text.secondary' sx={{ width: '246px' }}>
                                                {
                                                    language === 'alb' ? 'Lexo më shumë' : 'Read more'
                                                }
                                            </Button>
                                        </Box>
                                    </Grid>
                                ))
                            }
                        </Grid>
                    </>
            }
        </Grid>
    )
}